import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { HttpClient } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiIntegration } from "../../_services/api.integration";
//import { LocalStorageService, SessionStorageService } from "angular-web-storage";
import { User } from "../../_models/user";

@Component({
  selector: 'app-payment-confirmation',
  templateUrl: './payment-confirmation.component.html',
  styleUrls: ['./payment-confirmation.component.css']
})
export class PaymentConfirmationComponent implements OnInit {
  pay: any = {};
  constructor(private http: HttpClient, private router: Router, private route: ActivatedRoute, private api: ApiIntegration, private g: Globals, public user: User) {
    this.g.page = "Payment Status";
    this.api.getInvoicesById(this.route.snapshot.params['id']).subscribe((data: any) => { this.pay = data; }, err => { console.log(err); });
  }
  ngOnInit() {
  }

}
